// Color Palette --------------------------------------------------------------
const white = '#FFFFFF';
const black = '#000000';

export const palette = {
	white,
	black,
};

// Main Color Theme -----------------------------------------------------------
export const colors = {
	primary: black,
	secondary: white,
};

export default colors;



// WEBPACK FOOTER //
// ./src/styles/colors.js